import { Component, Input, OnInit } from '@angular/core';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-dot-slider',
  templateUrl: './dot-slider.component.html',
  styleUrls: ['./dot-slider.component.scss']
})
export class DotSliderComponent {

  @Input() length: number;
  @Input() indexActive: number;

  config: SwiperOptions;


  constructor() {
    this.config = {
      slidesPerView: 3,
      spaceBetween: 0,
      allowTouchMove: false,
      slideClass: 'dot-slide'
    };
  }


}
